/**
 * @file 资质信息
 * @author fuqiang15
 */

import ListModel from '@baidu/ve-ria/views/ListModel';
import {map, pick} from 'lodash';

export default class SchemaDataListModel extends ListModel {
    /**
     * @override
     */
    title = '';

    serviceId = this.getRouteParams().serviceId;

    schemaServiceListDatasource = [];

    filter = pick(this.filter, ['pageNo', 'pageSize']);

    init() {
        super.init();
        this.serviceListRequester = this.api.appServiceList;
        this.listRequester = this.api.appServiceFormReportList;
    }

    async requestServiceList() {
        let {result} = await this.serviceListRequester({
            type: 'SCHEMA',
            pageNo: 1,
            pageSize: 100
        });
        this.schemaServiceListDatasource = map(result, ({name, id}) => ({label: name, value: id}));
    }

    prepareQuery(query) {
        return {
            ...query,
            serviceId: this.getRouteParams().serviceId
        };
    }

}
